import { useState, useEffect } from 'react'
import styles from './Placeholder.module.css'
import globalStyles from '../styles/global.module.css'
import apiConfig from '../config/api'
import Layout from '../components/Layout'

const Placeholder = () => {
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  })
  const [startDate, setStartDate] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch(`${apiConfig.baseUrl}/api/settings`)
        const data = await response.json()
        
        if (data.hikeStartDate) {
          setStartDate(new Date(data.hikeStartDate))
        }
        setLoading(false)
      } catch (error) {
        console.error('Error fetching settings:', error)
        setLoading(false)
      }
    }
    
    fetchSettings()
  }, [])

  useEffect(() => {
    if (!startDate) return

    const calculateCountdown = () => {
      const now = new Date()
      const difference = startDate - now
      
      if (difference <= 0) {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 })
        return
      }
      
      const days = Math.ceil(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((difference % (1000 * 60)) / 1000)
      
      setCountdown({ days, hours, minutes, seconds })
    }
    
    const timer = setInterval(calculateCountdown, 1000)
    calculateCountdown()
    
    return () => clearInterval(timer)
  }, [startDate])

  const formatDate = (date) => {
    if (!date) return ''
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return date.toLocaleDateString('en-US', options)
  }

  if (loading) {
    return <div className={globalStyles.loading}>Loading...</div>
  }

  return (
    <Layout>
      <div className={styles.placeholderContainer}>
        {startDate && (
          <div className={styles.countdownBanner}>
            <div className={styles.bannerContent}>
              <span className={styles.startDateInfo}>Start date: {formatDate(startDate)}</span>
              <div className={styles.countdownDisplay}>
                <div className={styles.countdownUnit}>
                  <span className={styles.countdownValue}>{countdown.days}</span>
                  <span className={styles.countdownLabel}>d</span>
                </div>
                <div className={styles.countdownUnit}>
                  <span className={styles.countdownValue}>{countdown.hours}</span>
                  <span className={styles.countdownLabel}>h</span>
                </div>
                <div className={styles.countdownUnit}>
                  <span className={styles.countdownValue}>{countdown.minutes}</span>
                  <span className={styles.countdownLabel}>m</span>
                </div>
                <div className={styles.countdownUnit}>
                  <span className={styles.countdownValue}>{countdown.seconds}</span>
                  <span className={styles.countdownLabel}>s</span>
                </div>
              </div>
            </div>
          </div>
        )}
        
        <div className={styles.twoColumnLayout}>
          {/* Left Column - Map */}
          <div className={styles.leftColumn}>
            <img 
              src="/images/overview_map.png" 
              alt="Pacific Crest Trail Map" 
              className={styles.mapImage} 
            />
          </div>
          
          {/* Right Column - Title, Description, and Countdown */}
          <div className={styles.rightColumn}>
            <div className={styles.card}>
              <h1 className={styles.title}>Thru-hiking the PCT</h1>
              <p className={styles.description}>
                The Pacific Crest Trail (PCT) is a 2,650-mile hiking trail that runs from the Mexican border to the Canadian border through California, Oregon, and Washington. The route roughly follows the highest portion of the Sierra Nevada and Cascade mountain ranges.
              </p>
              <p className={styles.description}>On April 28, 2025 I will set out from the Southern terminus, located near the Mexican Border in Campo, California.</p>
            </div>
            <div className={styles.card}>
              <h1 className={styles.title}>Tracking my hike</h1>
              <p className={styles.description}>Follow this blog to stay up to date on my progress. I will try to post daily updates when I have internet access. I will also be carrying a satelite communicator, stay tuned for the link to track me that way.</p>
            </div>
            <div className={styles.card}>
              <h1 className={styles.title}>FAQs</h1>
              <p className={styles.description}>
                Check out the <a href="/faq" className={styles.link}>Frequently Asked Questions</a> page for answers to common questions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Placeholder 